// extracted by mini-css-extract-plugin
export var wrapperStyle = "search_refine_multi_select_checkbox_option-module--wrapperStyle--egUDs";